<template>
  <div class="widget-policy-selector">
    <h2 class="widget-policy-selector_title">Policy</h2>
    <ul role="list" class="flex flex-col gap-y-4">
      <li v-for="(policy, index) in policies" :key="index" class="flex">
        <WButton
          type="ghost"
          class="flex w-full flex-col items-start gap-y-4 !rounded-custom border border-backgroundSoft-600 p-4"
          @click="emit('onSelect', index)"
        >
          <div class="flex w-full justify-between">
            <h2 class="body1-bold text-start">{{ policy.number }}</h2>
            <div
              class="flex items-center rounded-xl px-3 py-0.5"
              :class="`${getPolicyStatus(policy) === 'Active' ? 'bg-positive-500' : 'bg-negative-500'}`"
            >
              <p class="body3 text-white">{{ getPolicyStatus(policy) }}</p>
            </div>
          </div>
          <div
            v-if="policy.vehicle?.licensePlate"
            class="rounded-md border border-l-[1.25rem] border-backgroundSoft-600 border-l-primary-500"
          >
            <p class="px-1.5 py-0.5 font-bold capitalize">{{ policy.vehicle.licensePlate }}</p>
          </div>
          <div v-if="policy.holder?.firstName || policy.holder?.lastName" class="flex items-center gap-x-2">
            <WidgetIcon :icon="themeIcons.person" class="widget-primary-icon size-6" />
            <p class="widget-policy-selector_name">
              {{ policy.holder.firstName || '' }} {{ policy.holder.lastName || '' }}
            </p>
          </div>
          <div v-if="policy.validFrom || policy.validTo" class="flex items-center gap-x-2">
            <WidgetIcon :icon="themeIcons.calendar" class="widget-primary-icon size-6" />
            <p class="widget-policy-selector_date">
              {{ getFormattedDate(policy.validFrom) }} - {{ getFormattedDate(policy.validTo) }}
            </p>
          </div>
        </WButton>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { config, themeIcons } from 'src/utils/config';

  import WButton from 'src/components/base/Button.vue';
  import { Policy } from 'src/types/widget';
  import dayjs from 'dayjs';
  import WidgetIcon from 'src/components/base/WidgetIcon.vue';

  const emit = defineEmits<{
    (event: 'onSelect', index: number): void;
  }>();
  const policies = computed(() => config.value.policy as Policy[]);

  function getFormattedDate(date: string | undefined) {
    if (date) {
      return dayjs(date).format('DD/MM/YYYY');
    }
    return 'Unknown';
  }

  function getPolicyStatus(policy: Policy) {
    if (!policy.validFrom || !policy.validTo) return 'Inactive';
    const validTo = dayjs.utc(policy.validTo, 'YYYY-MM-DD');
    const validFrom = dayjs.utc(policy.validFrom, 'YYYY-MM-DD');
    const now = dayjs.utc(dayjs.utc().format('YYYY-MM-DD'));
    if (now.isBefore(validFrom)) {
      return 'Not yet valid';
    }
    if (now.isAfter(validTo)) {
      return 'Expired';
    }
    return 'Active';
  }
</script>

<style scoped></style>
